import React from 'react'
import styles from './ModalInfo.module.scss'
import { useComponentLocale } from '../../hooks/useComponentLocale'

function ModalInfo({ info }) {
	const { filename, total, added, stack, spot, duplicates, lastLine } = info

	const getLocale = useComponentLocale()
	const spotLogLocale = getLocale({ component: 'uploadPage', section: 'spot_is_not_supported_log' })
	const stackLogLocale = getLocale({ component: 'uploadPage', section: 'stack_is_not_supported_log' })
	const addedLogLocale = getLocale({ component: 'uploadPage', section: 'added_log' })
	const totalLogLocale = getLocale({ component: 'uploadPage', section: 'total_log' })
	const duplicatesLogLocale = getLocale({ component: 'uploadPage', section: 'duplicates_log' })

	const fileName = filename === 'Total' ? totalLogLocale : filename

	const renderDetailsLogData = () => {
		const details = {
			total,
			added,
			stack,
			spot,
			duplicates,
		}

		const detailName = (name) => {
			const capitalizeFirstLetter = name[0].toUpperCase() + name.slice(1)

			switch (capitalizeFirstLetter) {
				case 'Duplicates':
					return `${duplicatesLogLocale}`
				case 'Stack':
					return `${stackLogLocale}`
				case 'Added':
					return `${addedLogLocale}`
				case 'Total':
					return `${totalLogLocale}`
				case 'Spot':
					return `${spotLogLocale}`
				default:
					return capitalizeFirstLetter
			}
		}

		return Object.keys(details).map((name) => (
			<p key={name}>
				{detailName(name)}: {details[name]}
			</p>
		))
	}

	return (
		<div className={styles.taskUploadLog}>
			<h4>{fileName}</h4>
			<div className={styles.taskUploadLogData}>{renderDetailsLogData()}</div>
			{lastLine}
		</div>
	)
}

export default ModalInfo
